import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styles from "./MessageOverlay.scss";
import classnames from "classnames";

function MessageOverlay({ children, visible }) {
  if (!visible) {
    return null;
  }
  return <div className={classnames("wbkv9-MessageOverlay", styles.container)}>{children}</div>;
}
MessageOverlay.propTypes = {
  children: PropTypes.object,
};

export default pure(MessageOverlay);
